/*
 * @Author       : lijie44
 * @File         : 推荐prompt or character
 * @Date         : 2023-11-10 13:08:39
 */

import {
    MODELMAP,
    SECOND_CARD_CONFIG,
    SEEK_TAB_PARAMS,
} from '@lib/constants';
import {ubcLog} from '@lib/log';
import {harmonyInterceptor} from '@lib/utils/decorator';
import {
    appVersionCompare,
    getFrameScheme,
    getQueryString,
} from '@lib/utils/tools';
import {Component} from '@src/lib/San';
import {onDomVisible} from '@src/lib/utils/dom';
import {isInNewApp} from '@src/lib/utils/env';
import {
    seekTab,
    showNaToast,
} from '@src/lib/utils/native';
import {THEME_MODE} from '@src/lib/utils/pageMode';
import {invokeSchema} from '@src/lib/utils/schema';
// @ts-ignore
import recommendDark from '../assets/dark/recommend-dark.png';
// @ts-ignore
import recommendLight from '../assets/light/recommend-light.png';
import * as I from '../types';
// @ts-ignore
import imgError from './assets/img_error.png';
import $style from './index.module.less';

export default class CSugCards extends Component {
    static template = /* html */ `
        <div
            class="{{$style.cSugCards}}
                {{isHistory ? $style.show : ''}}
                {{visible && !isHistory ? $style.visible : ''}}
                checked-bubble"
            style="{{cardBoxStyle}}"
        >
            <div
                s-ref="cardBox"
                class="{{$style.cardBox}}"
            >
                <div s-if="title" class="{{$style.titleTop}}">
                    {{ title }}
                </div>
                <div
                    s-for="item,index in sugBots"
                    s-ref="{{'item-'+index}}"
                    class="{{$style.card}}"
                    on-click="toChat(item, index)"
                >
                    <div class="{{$style.message}}">
                        <div class="{{ item | getIconStyle }}">
                            <img
                                class="{{$style.img}} no-view" src="{{item.imgUrl || imgError}}"
                                on-error="onImgError($event)"
                            >
                        </div>

                        <div class="{{$style.info}}">
                            <div class="{{$style.title}}">
                                <div class="{{$style.titleText}}">
                                    {{ item.title }}
                                </div>
                                <span s-if="item.certificationFlag" class="{{$style.iconCertification}}"></span>
                            </div>
                            <div class="{{$style.imgTip}}">
                                <img
                                    s-if="{{item.model == MODELMAP.professional}}"
                                    class="{{$style.img}}"
                                    src="{{sugImg}}"
                                >
                                <div s-if="!item.isHcg" class="{{$style.tips}}">
                                    {{ item.useNumInfo }}
                                </div>
                                <div s-else-if="item.useNumInfo && item.isHcg" class="{{$style.tips}}">
                                    <span s-for="desc in item.useNumInfo" class="{{$style.tipsDesc}}">
                                        {{ desc }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- newapp-00-3332 [Feature] 【产品】拜年视频二期：针对sug入口活动展示“去试试”文案 -->
                    <div s-if="from !== 'preview'" class="{{$style.btn}}">
                        <p>{{ item.type === SECOND_CARD_CONFIG.SUGACTIVITY ? '去试试' : (item.button || '去使用') }}</p>
                    </div>
                </div>
                <div
                    s-if="showViewMore" class="{{$style.toDiscoveryBtn}}"
                    on-click="seekToDiscovery"
                >
                    查看更多
                    <div class="{{$style.moreBtn}}"></div>
                </div>
            </div>
        </div>
    `;

    initData() {
        return {
            $style,
            visible: false,
            cardBoxStyle: {},
            imgError,
            recommendLight,
            recommendDark,
            MODELMAP,
            needLog: true,
            SECOND_CARD_CONFIG,
            from: '',
            // 卡片监听器
            cardObserver: null,
        };
    }

    created() {
        this.watchState([
            'theme',
            'showCheckBox',
        ]);
    }

    attached() {
        setTimeout(() => {
            this.data.set('visible', true);
            const card = this.ref<any>('cardBox');
            this.data.set('cardBoxStyle', {
                'height': `${card?.offsetHeight}px`,
            });
            this.emitter.emit('backFlowAttached', {
                querySelect: `.${this.data.get('$style.card')}`,
            });
        }, 10);

        // 兼容修改字体大小后卡片展示不全
        setTimeout(() => {
            this.data.set('cardBoxStyle', {
                'height': 'auto',
            });
        }, 300);

        const observer = onDomVisible({
            dom: this.el as HTMLElement,
            cb: this.recShowLog.bind(this),
        });
        this.data.set('cardObserver', observer);

        const sugBots = this.data.get('sugBots');
        const needRegisterWxTag = sugBots[0]?.isHcg && !isInNewApp;
        if (needRegisterWxTag) {
            setTimeout(() => {
                const hcgDom = this.ref('item-0') as unknown as HTMLElement;
                // 注册微信开放标签
                const ugInvoke = this.store.get('ugInvoke') || this.data.get('ugInvoke') || {};
                ugInvoke?.renderWxTag && ugInvoke?.renderWxTag({
                    wxConf: {
                        wxDom: hcgDom,
                    },
                    sceneName: 'chatshare_chat_params',
                });
            }, 200);
        }

    }
    // eslint-disable-next-line @typescript-eslint/member-ordering
    static computed: Computed = {
        sugImg() {
            const theme = this.data.get('theme');
            return theme === THEME_MODE.Dark ? recommendDark : recommendLight;
        },
    };
    static filters: Filters = {
        getIconStyle: (val: Record<string, unknown>) => {
            if (appVersionCompare('4.0') < 0) {
                return '';
            }
            return val?.isDigital === I.AgentType.DIGITAL ? $style.hasIcon : '';
        },
    };
    @harmonyInterceptor()
    toChat(item: object, index: number) {
        const from = this.data.get('from');
        const isPcClient = this.store.get('isPcClient');
        if (isPcClient) {
            return showNaToast('暂不支持，请前往文心APP查看消息');
        }

        if (from === 'preview') {
            return;
        }
        const showCheckBox = this.data.get('showCheckBox');
        if (showCheckBox) {
            return;
        }
        const {source, rdcExt, isHistory = '0'} = this.data.get('logInfo') || {};
        // type和id由上游配置，用于打点。目前type(id)取值：prompt/character/poemcard(1288)
        const {
            type,
            scheme,
            id,
            model,
            isHcg,
        } = item as any;
        // hcg端外不走智能体回主会话
        if (!isInNewApp) {
            if (isHcg) {
                const ugInvoke = this.store.get('ugInvoke') || this.data.get('ugInvoke') || {};
                ugInvoke?.execInvoke('chatshare_chat_params');
                return;
            }
            const uk = getQueryString('uk') || '';
            const sugBots = this.data.get('sugBots');
            const roleIdStr = sugBots[index]?.scheme?.indexOf('characterId') > -1
                ? `&characterId=${sugBots[index]?.id}`
                : `&promptId=${sugBots[index]?.id}`;
            // eslint-disable-next-line xss/no-location-href-assign
            window.location.href = `/talk/litechat?uk=${uk}${roleIdStr}&from=sugCards`;
            return;
        }
        if (isHcg) {
            ubcLog({
                params: {
                    type: 'click',
                    value: 'Medical_Inquiry',
                    from: 'new_app',
                    page: 'homepage',
                },
            });
        }
        else {
            this.log({
                source,
                ubcId: '6414',
                type: 'click',
                ext: {
                    ext: {
                        'rdc_ext': {
                            'rec_type': type,
                            'eb4.0': +(model === MODELMAP.professional),
                            'msg_id': this.data.get('id'),
                            ...rdcExt,
                        },
                    },
                    id: `${type}_${id}`,
                    pos: index + 1,
                    'is_history': isHistory,
                },
            });
        }
        if (scheme) {
            if (isHcg) {
                invokeSchema(scheme);
                return;
            }
            const frameScheme = getFrameScheme({
                scheme,
            });
            invokeSchema(frameScheme);
        }
    }

    // 推荐bot展现打点
    recShowLog() {
        const sugBots = this.data.get('sugBots');
        const {source, rdcExt, isHistory = '0'} = this.data.get('logInfo') || {};
        const logItme = [] as any[];
        let hitHcg = false;
        sugBots.forEach((item: any, index: number) => {
            const {type = '', id = '', model, isHcg} = item;
            !hitHcg && (hitHcg = isHcg);
            logItme.push({
                ext: {
                    'rdc_ext': {
                        'rec_type': type,
                        'eb4.0': +(model === MODELMAP.professional),
                        'msg_id': this.data.get('id'),
                        ...rdcExt,
                    },
                },
                id: `${type}_${id}`,
                pos: index + 1,
                'is_history': isHistory,
            });

        });
        if (hitHcg) {
            ubcLog({
                params: {
                    type: 'show',
                    value: 'Medical_Inquiry',
                    from: 'new_app',
                    page: 'homepage',
                },
            });
        }
        else {
            this.log({
                source,
                ubcId: '6412',
                type: 'show',
                ext: {
                    item: logItme,
                },
            });
        }
    }

    log(obj: I.RdcLogData) {
        const {ubcId, type, ext, source = ''} = obj;
        if (!this.data.get('needLog')) {
            return;
        }
        ubcLog({
            ubcId,
            params: {
                source,
                type,
                value: 'rec',
                page: 'homepage',
            },
            ext: {
                ...ext,
            },
        });
    }
    onImgError(e: Event) {
        const img = e.target as HTMLImageElement;
        img.src = imgError;
    }

    // 跳到发现Tab
    seekToDiscovery() {
        seekTab(SEEK_TAB_PARAMS.DISCOVERY);
    }

    detached() {
        this.data.get('cardObserver')?.disconnect();
    }
}

